import DocusaurusFooter from '../DocusaurusFooter'
import { Paragraph } from '@eggplant/pattern-library'
import { monitorConfig } from '../../docs-routes'

const MonitorConfigs = () =>
  <Paragraph>
    Monitor configs are test cases tests grouped in specific sequences to run against systems under test (SUTs) regularly, which will provide a series of test results against time that you can check in monitor results and dashboard page.
    <DocusaurusFooter path={monitorConfig} />
  </Paragraph>

export default MonitorConfigs
